type RuntimeEnvRecord = Record<string, string | undefined>;

declare global {
  interface Window {
    __ENV__?: RuntimeEnvRecord;
  }
}

const isBrowser = typeof window !== 'undefined';

function getRuntimeEnvRecord(): RuntimeEnvRecord {
  if (isBrowser) {
    return window.__ENV__ || {};
  }

  return {};
}

export function getRuntimeEnv(key: string, fallback?: string): string | undefined {
  const runtimeValue = getRuntimeEnvRecord()[key];

  if (runtimeValue !== undefined) {
    return runtimeValue;
  }

  const processValue = process.env[key];

  if (processValue !== undefined) {
    return processValue;
  }

  return fallback;
}

